module.exports = __webpack_public_path__ + "static/media/logo_destek.be47c1bc.png";